import React, {Component} from 'react';
//import Actions from '../../../actions/Actions.js';
import Remove from './Remove';

class QuantityNoControl extends Component {
  constructor(props) {
    super(props);

    this.state = {};

    this.is_free = this.props.item.final_price===0;
  };


  render() {
    return (
      <React.Fragment>
        <div className={"quantity_container"+(this.is_free?" invisible":"")}>
          <div className="icon minus" style={{"visibility":"hidden"}}>
              -
          </div>
          <div className="mx-2">{this.props.quantity}</div>
          <div className="icon plus" style={{"visibility":"hidden"}}>
              +
          </div>
        </div>
        <Remove
          item={this.props.item}
          variant_id={this.props.variant_id}
          class="mt-2"
        />
      </React.Fragment>
    )
  };
}
export default QuantityNoControl;